import {
  LOAD_ANALYTICS_ASSET_LIST,
  ADD_TRACKED_ASSET_TO_LIST,
  SORT_ANALYTICS_ASSET_LIST,
  FILTER_ANALYTICS_ASSET_LIST,
} from './constants';

export function loadAnalyticsAssetList() {
  return {
    type: LOAD_ANALYTICS_ASSET_LIST,
  };
}

export function sortAnalyticsAssetList(data) {
  return {
    type: SORT_ANALYTICS_ASSET_LIST,
    data,
  };
}

export function filterAnalyticsAssetList(data) {
  return {
    type: FILTER_ANALYTICS_ASSET_LIST,
    data,
  };
}

export function addTrackedAssetToList(data) {
  return {
    type: ADD_TRACKED_ASSET_TO_LIST,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset-list/actions.js
 **/